import _ from 'lodash';
import {isLoadByIframe} from '@/utils/util';

const ua = window.navigator.userAgent?.toLowerCase();
export const ENV = {
    isMobile: () => {
        return window.screen.availWidth <= 600 && !isLoadByIframe();
    },
    platform(): 'android' | 'ios' | 'browser' {
        if (_.includes(ua, 'android')) {
            return 'android';
        }

        if (_.includes(ua, 'iphone')) {
            return 'ios';
        }
        return 'browser';
    },

    // 安卓版本号判断
    androidVer: () => {
        return /android (.*?);/.exec(ua);
    },

    android: () => {
        return ua.includes('android') || ua.includes('adr');
    },

    ios: () => {
        return !!(/\(i[^;]+;( U;)? CPU.+Mac OS X/i).exec(ua);
    },

    iosBaiduyun: () => {
        return ENV.ios() && ENV.baiduyun();
    },
    // 百度智能云APP中打开
    baiduyun: () => {
        return _.includes(ua, 'bai du yun');
    },
    baiduYunVersion: () => {
        return ENV.baiduyun() ? window.navigator.appVersion : '';
    },
    iosVersion: () => {
        const vers = (/cpu iphone os (.*?) like mac os/).exec(ua);
        return vers && vers.length > 1 ? vers[1] : '';
    },
    baidu: () => {
        return ua.includes('baiduboxapp');
    },
    baiduVersion: () => {
        const part = ua.split('baiduboxapp/')?.[1] || '';
        return part ? part.split('(')?.[0] : '';
    },
};
